var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_678_2751)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.2077,
    cy: 58.2077,
    r: 58.2077,
    fill: "#478F96"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7312 31.5757L54.0439 76.2599C53.7434 76.5615 53.3864 76.8009 52.9932 76.9642C52.6 77.1275 52.1785 77.2115 51.7527 77.2115C51.327 77.2115 50.9055 77.1275 50.5123 76.9642C50.1191 76.8009 49.7621 76.5615 49.4616 76.2599L32.1804 58.9625C31.8799 58.6609 31.5229 58.4215 31.1297 58.2582C30.7366 58.0949 30.315 58.0108 29.8893 58.0108C29.4635 58.0108 29.042 58.0949 28.6488 58.2582C28.2556 58.4215 27.8986 58.6609 27.5981 58.9625C27.2965 59.2629 27.0572 59.62 26.8939 60.0132C26.7306 60.4063 26.6465 60.8279 26.6465 61.2536C26.6465 61.6793 26.7306 62.1009 26.8939 62.4941C27.0572 62.8872 27.2965 63.2443 27.5981 63.5447L44.8858 80.8292C46.7095 82.6495 49.1809 83.6718 51.7576 83.6718C54.3343 83.6718 56.8057 82.6495 58.6293 80.8292L103.313 36.1548C103.615 35.8544 103.854 35.4975 104.017 35.1046C104.18 34.7118 104.264 34.2906 104.264 33.8653C104.264 33.4399 104.18 33.0187 104.017 32.6259C103.854 32.233 103.615 31.8761 103.313 31.5757C103.013 31.2741 102.656 31.0348 102.263 30.8715C101.87 30.7082 101.448 30.6241 101.022 30.6241C100.597 30.6241 100.175 30.7082 99.7819 30.8715C99.3887 31.0348 99.0317 31.2741 98.7312 31.5757Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_678_2751",
    x: 0,
    y: 0,
    width: 126.415,
    height: 126.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.462745 0 0 0 0 0.239216 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_678_2751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_678_2751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.6103,
    height: 77.6103,
    fill: "white",
    transform: "translate(26.5576 17.2467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.53ac8254b504e9f1a14929e7b79dc152.svg";
export { ForwardRef as ReactComponent };